module.exports = __webpack_public_path__ + "img/jetrodder_parked.a79cee88.svg";